import { render } from "./StockItemEntire.vue?vue&type=template&id=b74056ca&scoped=true&ts=true"
import script from "./StockItemEntire.vue?vue&type=script&lang=ts"
export * from "./StockItemEntire.vue?vue&type=script&lang=ts"

import "./StockItemEntire.vue?vue&type=style&index=0&id=b74056ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74056ca"]])

export default __exports__